export default "__VITE_ASSET__CppWoYnX__"